import { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { getPortfolio } from 'src/redux/user_portfolio/thunks';
import {
    selectPortfolioError,
    selectPortfolioLoadedForParameter,
    selectPortfolioLoading,
} from 'src/redux/user_portfolio/user_portfolio.selectors';
import { RetentionSearchContext } from '../search';

/**
 * Carga perezosa del portafolio del usuario (`commercial_panel/portfolio`).
 *
 * Dispara `getPortfolio` con el correo del buscador central cuando la pestaña se
 * abre o cambia el usuario buscado. El guard `loadedForParameter` evita refetch
 * al alternar entre las pestañas que comparten estos datos (Vigencias/Asignaciones).
 */
export const useLazyPortfolio = () => {
    const dispatch = useAppDispatch();
    const { submittedQuery } = useContext(RetentionSearchContext);
    const loading = useAppSelector(selectPortfolioLoading);
    const error = useAppSelector(selectPortfolioError);
    const loadedForParameter = useAppSelector(selectPortfolioLoadedForParameter);
    const isLoaded = !!submittedQuery && loadedForParameter === submittedQuery;

    useEffect(() => {
        if (!submittedQuery) return;
        if (loading) return;
        if (loadedForParameter === submittedQuery) return;
        dispatch(getPortfolio({ parameter: submittedQuery }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submittedQuery]);

    return { submittedQuery, loading, error, isLoaded };
};
